import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=a5c7b4b2&"
import script from "./Views.vue?vue&type=script&lang=ts&"
export * from "./Views.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports